/**
 * Description  : 纳米盒APP与WEB交互jssdk
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2021-11-10 11:56:32
 * LastEditors  : Luoye
 * FilePath     : /namibox_client_web/src/libs/app-jssdk.lib/core/main.ts
 * Copyright (C) 2021 rose. All rights reserved.
 */

import { resolve } from 'path';

declare global {
  interface Window {
    jssdk: NAMIBOX_APP_JSSDK;
    jsapp_command: () => void;
    jsapp_register: () => void;
    android_app_ready: () => void;
    js_app_send: (
      data: SendMessageObject,
      responseCallback?: CallbackFuntion
    ) => boolean;
    app_js_hanler: (
      data: ReceiveMessageObject,
      responseCallback: CallbackFuntion
    ) => void;
    WebViewJavascriptBridge: {
      _fetchQueue: Function;
      _handleMessageFromObjC: Function;
      send: (
        message: SendMessageObject,
        responseCallback?: CallbackFuntion
      ) => void;
      init: <T = void>(params?: any) => T;
    };
    AndroidWebViewJavascriptBridge: Boolean;
  }
}

/** 回调函数 */
type CallbackFuntion = (params?: any) => void;

//type CallbackFuntion = <T>(params?: any) => void;

/**接收到的信息对象 */
interface ReceiveMessageObject {
  command: string;
  [propname: string]: any;
}

/** 发送给APP Nactive的标准消息 */
interface SendMessageObject {
  command:
    | string
    | 'register'
    | 'context'
    | 'regtoken'
    | 'notify'
    | 'clear_notify'
    | 'refresh_html'
    | 'openMiniProgram'
    | 'scanQRCode'
    | 'getcurposition'
    | 'refreshview'
    | 'openview'
    | 'save_picture'
    | 'view_photos'
    | 'magic_book_detail_top_banner'
    | 'backshowcontrol'
    | 'request_native_actions';

  native_actions?: any[];

  /**openMiniProgram */
  mini_program_id?: string;
  mini_program_path?: string;
  mini_program_type?: 'preview' | 'test' | 'release';

  /**scanQRCode */
  scanType?: ('qrCode' | 'barCode')[];

  /**getcurposition */
  advance?: string;

  /**refreshview */
  hidden?: number;
  view_name?: string;
  refresh_url?: string;

  /**openView */
  region_name?: string;
  // view_name: string;
  url?: string;
  slide_direction?: 'left' | 'right' | 'top' | 'bottom';
  keeplight?: 0 | 1;
  lighteness?: number;

  /**save_picture */
  pic_url?: string;

  /**view_photos */
  start_pos?: number;
  thumbnail?: string[];
  large_pic?: string[];
  original_pic?: string[];

  /**notify、clear_notify */
  msgid?: number;
  /**
   * notify command
   */
  title?: string;
  subtitle?: string;
  alerttime?: number;
  soundflag?: 0 | 1;
  always_tone?: 0 | 1;
  limit?: number;
  icon?: string;
  //url?: String;

  /**
   * context command
   * operation 参数：弹出设置页面(setting)、分享到朋友圈(sharetimeline)、分享给好友(sharefriend)
   */
  operation?:
    | 'sharefriend'
    | 'sharetimeline'
    | 'qq'
    | 'qzone'
    | 'setting'
    | 'share'
    | '';
  wxshare?: WXShare;

  [propName: string]: any;
  message_name?: string[];
}

export interface WXShare {
  sharelist?: string[];
  url_image: string;
  url_link: string;
  share_content: string;
  share_title: string;
  share_friend: string;
  appid?: string;
  mini_program_id?: string;
  mini_program_path?: string;
  mini_program_type?: 'preview' | 'test' | 'release';
  ignoreresult: boolean; //是否显示toast
}

/**分享给好友 */
interface Command_sharefriend {
  command: 'context';
  operation: 'sharefriend';
}

/**分享到朋友圈 */
interface Command_sharetimeline {
  command: 'context';
  operation: 'sharetimeline';
}

/**分享小程序给好友 */
interface Command_shareWeixinProgram {
  command: 'context';
  operation: 'sharefriend';
  wxshare: WXShare;
}

/**发送通知 */
interface Command_notify {
  command: 'notify';
  msgid: number;
  title: string;
  subtitle: string;
  alerttime: number;
  soundflag: 0 | 1;
  always_tone: 0 | 1;
  limit: number;
  icon: string;
  url: String;
}

/**清除通知 */
interface Command_clearNotify {
  command: 'clear_notify';
  msgid: number;
}

/**打开微信小程序页面 */
interface Command_openMiniProgram {
  command: 'openMiniProgram';
  mini_program_id: string;
  mini_program_path: string;
  mini_program_type: 'preview' | 'test' | 'release';
}

/**打开扫码 */
interface Command_scanQRCode {
  command: 'scanQRCode';
  scanType: ('qrCode' | 'barCode')[];
}

/**刷新整个webview */
interface Command_refreshview {
  command: 'refreshview';
  hidden: number;
  view_name: string;
  refresh_url: string;
}

/**打开webview */
interface Command_openview {
  command: 'openview';
  region_name: string;
  view_name: string;
  url: string;
  slide_direction: 'left' | 'right' | 'top' | 'bottom';
  /**屏幕常亮为0 */
  keeplight: 0 | 1;
  lighteness: number;
}

/**保存图片到本地 */
interface Command_savePicture {
  command: 'save_picture';
  pic_url: string;
}

/**浏览图片 */
interface Command_viewPhotos {
  command: 'view_photos';
  start_pos: number;
  thumbnail: string[];
  large_pic: string[];
  original_pic: string[];
}

interface SystemInfo {
  app_version: string;
  app_version_code?: string | number;
  app_channel?: string;
  hardware?: any;
  os_version?: string;
  os_name: string;
  network?: string;
  [propName: string]: any;
}

interface SysBaseInfo {
  platform: 'ios' | 'android' | 'other';
  isNamibox: boolean;
  isiOS: boolean;
  isAndroid: boolean;
  isPC: boolean;
}

interface UserInfo {
  userid?: string | number;
  sessionid?: string;
  status?: string | number;
  changetime?: string | number;
  phoneNumber?: string | number;
  nick_name?: string;
  role?: string;
  head_image?: string;
  [propName: string]: any;
}

/**报告类型 */
type ReportType = 'error' | 'warn' | 'info' | 'log';

class NAMIBOX_APP_JSSDK {
  /**是否开启debug模式 */
  private __debugger: boolean;

  /**发送消息缓存列表 */
  private __cacheSendMessageList: any[];

  /**回调方法缓存列表 */
  private __cacheCallbackList: CallbackFuntion[];

  /**缓存订阅消息的回调行数列表 */
  private __cacheSubscribeCallbackList: {
    [key: string]: { callback: CallbackFuntion; once?: boolean }[];
  };

  /**系统信息 */
  systemInfo: SystemInfo;

  /**系统基础信息 */
  sysBaseInfo: SysBaseInfo;

  /** 用户信息 */
  userInfo: null | UserInfo;

  constructor(_debugger: boolean = false) {
    this.__debugger = _debugger;
    this.__cacheSendMessageList = [];
    this.__cacheCallbackList = [];
    this.__cacheSubscribeCallbackList = {};
    this.userInfo = null;
    this.systemInfo = { app_version: '', os_name: '' };

    const ua = navigator.userAgent;
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    this.sysBaseInfo = {
      isAndroid,
      isiOS,
      isPC: !isAndroid && !isiOS,
      isNamibox: /NamiBox/i.test(ua),
      platform: isAndroid ? 'android' : isiOS ? 'ios' : 'other',
    };
    this.init();
  }

  /**debug模式开启关闭 */
  debugger(flag: boolean = false) {
    this.__debugger = flag;
  }

  /**初始化 */
  private init() {
    this.__OLD_VERSION_FUNTIONS();
    this.registerCustomEvent();
    document.addEventListener('AndroidWebViewJavascriptBridge', () => {
      window.AndroidWebViewJavascriptBridge = true;
      this.appReady();
    });
    try {
      //防止报WebViewJavascriptBridge报错(测试貌似不行)
      /*
			if(!window.WebViewJavascriptBridge){
				window.WebViewJavascriptBridge={};
			}
			 if (!window.WebViewJavascriptBridge._fetchQueue) {
        window.WebViewJavascriptBridge._fetchQueue = () => {};
      }
      if (!window.WebViewJavascriptBridge._handleMessageFromObjC) {
        window.WebViewJavascriptBridge._handleMessageFromObjC = () => {};
      } */

      // iOS使用了WebViewJavascriptBridge中间件，页面就绪后或收到该对象就绪的消息
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        () => {
          window.WebViewJavascriptBridge?.init(window.app_js_hanler);
          this.appReady();
        },
        false
      );
    } catch (e) {
      console.error('初始化失败啦');
    }

    this.appReady(() => {
      this.getSystemInfo();
    });
  }

  /**历史版本调用方法支持 */
  private __OLD_VERSION_FUNTIONS() {
    //var win = typeof window === 'undefined' ? global : window;
    window.jssdk = this;
    window.js_app_send = this.send.bind(this);
    window.jsapp_command = this.command.bind(this);
    window.jsapp_register = this.register.bind(this);
    window.android_app_ready = this.registerCustomEvent.bind(this); //android_app_ready()由Android APP触发
    window.app_js_hanler = this.receive.bind(this);
  }

  /**
   * ajax请求
   * @param url 请求地址
   * @param method 请求方法 默认GET
   * @param data 请求数据
   * @param header 请求头
   * @returns Promise
   */
  ajax(
    url = '',
    method = 'GET',
    data: any = '',
    header: any = {
      'Content-type': 'application/json',
    }
  ) {
    return new Promise((resolve, reject) => {
      if (!url) {
        reject('url is empty');
      }
      if (!/^https?:\/\//.test(url)) {
        const host = window.location.origin;
        if (/m.namibox.com/.test(host)) {
          url = `https://namibox.com${url}`;
        } else if (/m-test.namibox.com\/144/.test(window.location.href)) {
          url = `https://namibox.com${url}`;
        } else if (/m-test.namibox.com/.test(host)) {
          url = `https://wweb.namibox.com${url}`;
        } else {
          url = `https://wweb.namibox.com${url}`;
        }
      }
      let params: any = data;
      let _url: any = url;
      if (typeof data === 'object') {
        params = [];
        const _tmpdata: any = {};
        if (method === 'GET') {
          _url = url.split('?');
          if (_url.length > 1) {
            _url[1].split('&').forEach((_kv: any) => {
              _kv = _kv.split('=');
              _tmpdata[_kv[0]] = _kv[1] || '';
            });
          }
        }
        Object.keys({ ..._tmpdata, ...data }).forEach((k) => {
          params.push(`${k}=${data[k] || ''}`);
        });

        if (method === 'GET') {
          url = `${_url[0]}?${params.join('&')}`;
        } else if (method === 'POST') {
          params = JSON.stringify(data);
        }
      }
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.withCredentials = true;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          let resData = xhr.responseText;
          try {
            resData = JSON.parse(resData);
          } catch (error) {}
          if (this.__debugger) {
            console.log({ jssdk_Ajax_received: { url, method, resData } });
          }
          resolve(resData);
        }
      };
      Object.keys(header).forEach((_hkey: string) => {
        xhr.setRequestHeader(_hkey, header[_hkey]);
      });
      if (this.__debugger) {
        console.log({ jssdk_Ajax_send: { url, method, data, header, params } });
      }
      xhr.send(params);
    });
  }

  /**
   * 获取用户信息
   * @return {Promise<UserInfo>}
   */
  getUserInfo(): Promise<UserInfo> {
    return new Promise((reslove) => {
      if (this.userInfo) {
        reslove(this.userInfo);
      }

      const ret: UserInfo = {
        userid: '',
        sessionid: '',
      };

      this.command('app_ready_succ');
      this.command(
        'query_user_config',
        'maps',
        {
          user_loginstatus: '',
          login_user_info: '',
          h5_temp_user_info: '',
        },
        async (res: any) => {
          if (this.__debugger) {
            console.log({ 用户信息: { os: this.systemInfo.os_name, res } });
          }
          const _u = JSON.parse(res['h5_temp_user_info'] || '{}');
          res = JSON.parse(res['user_loginstatus'] || '{}');
          if (this.systemInfo.os_name.toLowerCase() === 'android') {
            //android保存的用户数据不全需要重新获取
            if (res.userid && res.userid !== _u.userid) {
              res = await this.ajax('/auth/getuserinfo').then((_res: any) => {
                if (_res.code === 0) {
                  //把数据再次保存在本地
                  this.send({
                    command: 'user_config',
                    maps: {
                      h5_temp_user_info: JSON.stringify(_res),
                    },
                  });
                }
                return _res;
              });
            } else {
              if (_u.userid) {
                res = _u;
              }
            }
          }
          //判断登录状态 (cookie过期时间)
          const _changetime =
            res.changetime &&
            new Date(
              `${res.changetime}`.replace(
                /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
                '$1/$2/$3 $4:$5:$6'
              )
            ).getTime();

          if (!(res.status === 'login' && _changetime > new Date().getTime())) {
            //未过期
            res = { ...res, status: 'expires' };
          }
          /* if (res.status === 'login' && _changetime > new Date().getTime()) {
            //未过期
          } else {
            //已过期
            res = { ...res, status: 'expires' };
          } */
          this.userInfo = res;
          // console.log({ User: { os: this.systemInfo.os_name, res } });
          reslove(res);
        }
      );

      setTimeout(() => {
        //如果客户端1秒未做出回应
        if (!this.userInfo && this.sysBaseInfo.isNamibox) {
          this.ajax('/auth/getuserinfo').then((res: any) => {
            if (res.code === 0) {
              this.userInfo = res;
              reslove(res);
            } else {
              reslove(ret);
            }
          });
        }
      }, 2000);
    });
  }

  /**
   * 将APP查询返回的版本号转为整数
   * @param {string} version
   * @return {number}
   * @example 如1.0转换为10000，1.0.2转换为10002
   */
  private convert_app_version(version: string): number {
    const _v = version.split('.');
    const count_append = 3 - _v.length;
    for (let index = 0; index < count_append; index++) _v.push('0');
    return (
      parseInt(_v[0], 10) * 10000 +
      parseInt(_v[1], 10) * 100 +
      parseInt(_v[2], 10)
    );
  }

  /**
   * 获取系统信息
   * @return {SystemInfo}
   */
  getSystemInfo(): Promise<SystemInfo> {
    let ret: SystemInfo = { app_version: '', os_name: '' };
    const _info = navigator.userAgent.match(/NamiBox\/(.*)\/([\d.]+).*/i);
    if (_info) {
      ret = {
        os_name: _info[1] || '',
        app_version: _info[2] || '0.0.0',
        app_version_code: this.convert_app_version(_info[2] || '0.0.0'),
      };
    }
    this.systemInfo = ret;

    return new Promise((reslove) => {
      //this.command('app_ready_succ');
      this.command('querysys', 'advance', 'yes', (res: any) => {
        const { app_env = {}, sys_env = {}, hardware = {} } = res || {};
        Object.assign(ret, app_env, sys_env, { hardware });
        if (ret.os_name === '' || ret.app_version === '') {
          this.report_error(`未能查询到正确的版本信息`, {
            name: 'appjssdk调用失败',
            message: `客户端未检测到正确的版本信息 command('querysys', 'advance', 'yes')`,
            stack: res,
          });
        }
        this.systemInfo = ret;
        reslove(ret);
      });
    });
  }

  /**
   * 报告
   * @param {*} msg - 报告信息
   * @param {string} type - 报告类型 [info|error|warn|log]
   */
  report(msg: string, type: ReportType = 'info') {
    if (typeof msg === 'object') {
      msg = JSON.stringify(msg);
    }
    if (this.__debugger) {
      console[type](msg);
    }
  }

  /**
   * 错误报告
   * @param {*} msg - 信息内容
   * @param {*} e - js error对象
   */
  report_error(msg: string, e?: Error) {
    console.error(e);
    let data = msg;
    if (e) {
      data = `
        错误内容：${msg}
        <br>名字：${e.name}
        <br>信息：${e.message}
        <br>堆栈：${e.stack}
        `;
    }
    this.report(data, 'error');
  }

  /**
   * 在APP Native消息总线中注册消息事件
   * (注册后，客户端中需要广播消息都会触发相应事件，使用this.subscribe()来订阅消息事件)
   * @param {array} args
   */
  register(...args: string[]) {
    const data = [];
    for (let i = 0; i < arguments.length; i++) {
      data.push(arguments[i]);
    }
    this.command('register', 'message_name', data);
  }

  /**
   * 订阅系统广播消息
   * @param {string} name - 消息名称
   * @param {CallbackFuntion} callback - 回调方法
   */
  subscribe(name: string, callback: CallbackFuntion, once?: boolean) {
    this.register(name); //注册事件名
    const _name = `on_appcmd_${name}`; //ios中写死了on_appcmd_前缀所以必须加上（坑爹）
    if (this.__cacheSubscribeCallbackList[_name]) {
      this.__cacheSubscribeCallbackList[_name].push({ callback, once });
    } else {
      this.__cacheSubscribeCallbackList[_name] = [{ callback, once }];
    }
  }

  /**
   * 订阅系统广播消息一次
   * @param {string} name
   * @param {CallbackFuntion} callback
   */
  once_subscribe(name: string, callback: CallbackFuntion) {
    this.subscribe(`${name}`, callback, true);
  }

  /**
   * 执行订阅回调
   * @param {ReceiveMessageObject} data - 系统消息数据
   */
  private applySubscribeCallback(
    data: ReceiveMessageObject,
    responseCallback: CallbackFuntion
  ) {
    let { command: name } = data;
    if (name === 'message') {
      this.applayAppMessageCallback(data);
      name = data.message;
    }
    const _name = `on_appcmd_${name}`;

    const cmd = data.command;

    const __once_name: string[] = [];
    this.__cacheSubscribeCallbackList[_name] instanceof Array &&
      this.__cacheSubscribeCallbackList[_name].forEach((f) => {
        f.callback(data);
        if (responseCallback) {
          try {
            let ret_val: any = f.callback(data);
            if (window.WebViewJavascriptBridge) {
              // iOS直接使用WebViewJavascriptBridge将返回值通过responseCallback送回去
              if (responseCallback) {
                responseCallback(ret_val);
              }
            } else {
              // Android通过调用prompt，将响应反推回去
              // JSON结构中command关键字就设置为请求的command，转换为字符串作为prompt的参数。
              if (ret_val !== null) {
                ret_val['command'] = cmd;
              } else {
                ret_val = { command: cmd };
              }
              // 对APP传递过来message消息忽略其响应，Android目前做不到双向通信
              if (cmd !== 'message' && cmd !== 'pushmsg') {
                prompt(JSON.stringify(ret_val));
              }
            }
          } catch (e: any) {
            console.log('e', e);
          }
        }
        f.once && __once_name.push(_name);
      });

    __once_name.forEach((name) => {
      //清除一次性订阅方法
      delete this.__cacheSubscribeCallbackList[name];
      //解除消息总线中注册的事件
      this.command('unregister', 'message_name', name);
    });
  }

  /**
   * 处理系统全局性消息
   * @param {any} message
   */
  private applayAppMessageCallback(_message: any = {}) {
    const { message = '', redirect_url = window.location.href } = _message;
    switch (message) {
      case 'redirect':
        window.location = redirect_url;
        break;
      default:
        break;
    }
  }

  /**
   * 统一接收APP消息并按照名字派发
   * @param {*} message - 消息
   * @param {function} responseCallback - 回调方法
   */
  receive(data: any, responseCallback: CallbackFuntion) {
    if (window.AndroidWebViewJavascriptBridge) {
      data = JSON.parse(data);
    }
    // const { command, message } = data as ReceiveMessageObject;
    this.applySubscribeCallback(data, responseCallback);
  }

  /**
   * 发送消息给APP Native
   * @param {object} message - 发送的消息
   * @param {fucntion} responseCallback - 回调方法
   */
  send(
    message: SendMessageObject,
    responseCallback: CallbackFuntion = () => {}
  ) {
    const { command = '未知命令' } = message;

    if (this.__debugger) console.log(message);

    if (window.WebViewJavascriptBridge) {
      try {
        window.WebViewJavascriptBridge.send(message, responseCallback);
        //订阅消息回调方法
        responseCallback && this.subscribe(command, responseCallback);
        return true;
      } catch (e: any) {
        this.report_error(`Web到APP请求[${command}]异常！`, e);
        return false;
      }
    } else if (window.AndroidWebViewJavascriptBridge) {
      //appReady
      let ret_val: any = null;
      try {
        if (
          navigator.userAgent.search(/NamiBox/) > -1 ||
          navigator.userAgent.search(/NBDiYi/) > -1 ||
          navigator.userAgent.search(/AIClass/) > -1 ||
          navigator.userAgent.search(/Shumeiyun/) > -1
        ) {
          ret_val = prompt(JSON.stringify(message)) || ret_val;
        } else {
          this.report_error(`[${command}]未在纳米盒客户端中调用`);
          return false;
        }
      } catch (e: any) {
        this.report_error(`Web到APP请求[${command}]异常！`, e);
      }
      try {
        if (ret_val === null) {
          //订阅消息回调方法
          responseCallback && this.subscribe(command, responseCallback);
        } else {
          //andriod中是可以立即返回值
          responseCallback && responseCallback(JSON.parse(ret_val));
        }
      } catch (e: any) {
        this.report_error(`Web到APP请求[${command}]响应回调异常！`, e);
      }
      return true;
    } else {
      this.appReady(() => {
        this.send(message, responseCallback);
      });
      return false;
    }
  }

  /**
   * 基本执行命令方法
   * @param {string} arg[0] - 命令名
   * @param {string} arg[1] - key
   * @param {*} arg[2] - value
   * @param {function} arg[last] - 回调方法
   * @example this.command('refresh_html' , key , val ,.....)
   */
  command(...args: any[]) {
    if (arguments.length < 1) throw '调用command函数至少有1个参数！';

    // 最后一个参数是回调函数，可选
    let callback: any = null;
    if (typeof arguments[arguments.length - 1] === 'function')
      callback = arguments[arguments.length - 1];

    if (
      (callback && arguments.length % 2) ||
      (!callback && !(arguments.length % 2))
    )
      throw '调用command的参数个数不正确！';

    // 准备调用的参数
    const param_call: any = { command: arguments[0] };
    for (
      let i = 1;
      i < (callback ? arguments.length - 1 : arguments.length);
      i += 2
    ) {
      param_call[arguments[i]] = arguments[i + 1];
    }

    this.send(param_call, callback);
  }

  private registerCustomEvent(type = 'android') {
    const _customEvent = new CustomEvent('AndroidWebViewJavascriptBridge');
    document.dispatchEvent(_customEvent);
  }

  /**
   * APP准备就绪
   * @param {function} callback - 回调方法
   */
  appReady(callback: CallbackFuntion = () => {}) {
    if (
      window.WebViewJavascriptBridge ||
      window.AndroidWebViewJavascriptBridge
    ) {
      this.__cacheCallbackList.forEach((cb) => {
        cb && cb();
      });
      this.__cacheCallbackList = [];
      callback();
    } else {
      this.__cacheCallbackList.push(callback);
    }
  }
}

export default NAMIBOX_APP_JSSDK;
export const jssdk = window.jssdk ? window.jssdk : new NAMIBOX_APP_JSSDK();

/**使用范例 
 * 
  //确保app已经准备好后正常执行
  jssdk.appReady(function(){
    jssdk.send({command:'magic_book_detail_top_banner', banner_list:[]})
  })

  //如果app未准备好，调用不会成功
  jssdk.send({
    command: 'context',
    operation: 'sharetimeline',
  }, (res) => {
    console.log(res, '返回数据啦');
  });

  window.js_app_send({
    command: 'openview',
    url: 'https://wweb.namibox.com/vschool/preview/exercises/verify?v=36403',
  });

	// 注册监听广播事件
	jssdk.appReady(() => {
		jssdk.subscribe('broadcast_bring_book', (data: any) => {
			console.log(data, '收到广播数据了');
		});
	});

	// 客户端执行广播消息
	jssdk.send({
		command: 'message',
		message: 'broadcast_bring_book',
	});

	// 重要说明：广播事件一般可油服务端返回给客户端，客户端再执行相关命令广播消息
	// 服务端response消息列子如下：
	response = {
		commmand: 'request_native_actions',
		native_actions: [
			{
				command: 'message',
				message: 'broadcast_bring_book',
			},
			{
				command: 'showalert',
				title: u"恭喜您，领取成功",
				content: u"您可以随时在学习页面中打开书本并进行阅读哦~",
				actions:[{name: u"知道了"}]
			}
		]
	}

	//隐藏客户端后退按钮
	jssdk.send({ command: 'backshowcontrol', show: false });

	//客户端黑色模式
	jssdk.send({ command: 'statusbarcontrol', dark: true },)

	//禁止客户端后退按钮功能
	window.jssdk.send({
		command: 'backcontrol',
		action: 'page_quit',
		app_handle: false,
	});
	//防止ios客户端滑动后退
	window.jssdk.send({
		command: 'popgesture',
		enable: false,
	});

	//监听android返回事件
	if (platform === 'android') {
		window.jssdk.subscribe('backcontrol_callback', () => {
			// 在这里处理相关逻辑
			window.jssdk.send({ command: 'closeview' });
		});
	}

	//改变浏览器title
	window.jssdk.send({
		command: 'changetitle',
		title,
		// view_name: 'exam-analyse',
	});

	//保存数据到本地
	window.jssdk.send({
		command: 'user_config',
		maps: {
			version: 123,
		},
	});

	//打开透明窗口(此方法不能遮蔽任务栏)
	window.jssdk.send({
		command: 'openpopup',
		url: 'https://m-test.namibox.com/share-poster-page/index.html#/index?share_source=书架>鱼塘>分享赚金币',
		slide_direction: 'bottom',
	});
	//对应关闭透明窗口
	window.jssdk.send({
		command:'closepopup'
	})

	//打开透明窗口(此方法是全屏的)
	window.jssdk.send({
		command: 'showalert',
		newalert: {
			popup_url:
				'https://m-test.namibox.com/share-poster-page/index.html#/index?share_source=书架>鱼塘>分享赚金币',
			sub_type: 3,
			showIgnoreVschoolAndLogin: 0,
			alert_id: 'remind_user_get_fish',
			isBottom: true,
		},
	});
	//对应关闭透明窗口
	window.jssdk.send({
		command:'close_popup'
	})

	//任意地方弹出网页窗（新）
	window.jssdk.send({
		command: 'app_popup',
		url: `${PAGE_HOST}/share-poster-page/index.html#/index?open_command=openpopup&share_source=${encodeURIComponent(
			'书架>鱼塘>分享赚金币'
		)}`,
		view_name: 'share_poster_view',
		filletRadius: 0,
		bgColor: '#00000000', //argb
		leftMargin: 0,
		topMargin: 0,
		widthPercent: 1,
		heightPercent: 1,
		hasAnim: false, //不需要动画
		hasLoading: true, //是否显示loading动画
	});

	//分享到朋友圈
	window.jssdk.send(
		{
			command: 'context',
			operation:'sharetimeline',
			wxshare: {
				url_image: 'https://wf.namibox.com/auto/image/poster/87099379/3216de5bb7111296238e58ee3d2a9db9.jpg',
				ignoreresult: false, //是否显示分享成功toast
			},
		},
		(res: any) => {
			//调起分享界面成功，并不代表真分享成功了
		}
	);
	window.jssdk.subscribe('nmshareresult', (data: any) => {
		console.log(data, '真正分享成功啦');
	});

	//分享到微信小程序
	window.jssdk.send({
		operation: 'sharefriend',
		command: 'context',
		wxshare: {
			share_friend: '',
			mini_program_path:
				'pages/index/index?share_sign=648JN5VQFLIMCKNY&filename=48cdb6264874ae04052e5fae5b52f620.jpg',
			share_content: '',
			appid: 'wx210d6d66ba34cc83',
			share_title: '分享到微信小程序',
			mini_program_type: 'preview',
			mini_program_id: 'gh_2993d7628142',
			url_image:
				'https://wf.namibox.com/oms/qywxposter/87103471/ss_1656484351474.jpg',
			url_link: 'https://namibox.com/',
			ignoreresult: true,
		},
	});

	//打开加微小程序
	window.jssdk.send({
		tga_event: {
			event_name: 'nb_app_click',
			properties: {
				button: '小程序企业微信加微页面',
				page: '企业微信加微入口',
				source: 'fishpond',
			},
		},
		command: 'openMiniProgram',
		mini_program_id: 'gh_814ed41f4a7f',
		mini_program_path: `pages/textbook_add_wechat/index?source=fishpond&user_id=${__userid}`,
		needloginalert: 'true',
		forcelogin: 'true',
		mini_program_type:
			APP_ENV === 'test' || APP_ENV === 'development'
				? 'preview'
				: 'release',
	});
 * 
*/
